<template>
  <v-row no-gutters  justify="center">
    <v-col class="pa-6" cols="12">
      <h2 class="mt-0 text-h2">Kirjaudu sisään QR-koodilla</h2>
      <p>Löydät koodisi kirjeestä.</p>
      <v-btn tile block color="color-project-1" class="color-white--text" @click="showQRLoginDialog = true">
        {{ $t('loginButton') }}
        <v-dialog v-model="showQRLoginDialog"
                  :fullscreen="dialogSettings.fullscreen"
                  :scrollable="dialogSettings.scrollable"
                  :hide-overlay="dialogSettings.hideoverlay"
                  :transition="dialogSettings.transition"
                  :width="dialogSettings.width"
                  :max-width="dialogSettings.maxwidth"
                  content-class="full-screen-dialog">
          <v-card class="align-center">
            <v-toolbar flat light color="white" v-if="dialogSettings.fullscreen">
              <v-toolbar-title>Lue QR-koodi</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="showQRLoginDialog = false">
                <v-icon>fa-times</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-container class="fill-height pa-0" fluid>
              <v-row no-gutters>
                <v-card-text>
                  <v-col cols="12" class="py-4" v-if="showQRLoginDialog">
                    <qrcode-stream @decode="onDecode" @init="onInit">
                      <em></em>
                      <div class="scanner" v-if="initialized"></div>
                    </qrcode-stream>
                  </v-col>
                  <v-col cols="12" v-if="error !== ''">
                    <p>{{ $t(error) }}</p>
                  </v-col>
                  <v-col cols="12">
                    <v-btn tile block color="primary" @click="showQRLoginDialog = false">{{ $t('cancel') }}</v-btn>
                  </v-col>
                </v-card-text>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data () {
      return {
        showQRLoginDialog: false,
        initialized: false,
        error: ''
      }
    },
    computed: {
      dialogSettings () {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      }
    },
    methods: {
      onDecode (result) {
        var resultObj = JSON.parse(result)
        if (resultObj && resultObj.orderNr !== null && resultObj.onlineId !== null) {
          console.log(result, resultObj, resultObj.orderNr, resultObj.onlineId)
          this.authenticateWithQR(resultObj.orderNr, resultObj.onlineId)
        }
      },
      authenticateWithQR (orderNr, onlineId) {
        var credentials = {
          LoginType: 2,
          Username: orderNr,
          Password: onlineId
        }
        this.$store.dispatch('authenticateUser', credentials)
      },
      async onInit (promise) {
        this.initialized = false
        this.error = ''
        try {
          await promise
        } catch (error) {
          this.error = 'QRReaderError.' + error.name
        } finally {
          this.initialized = true
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "QRReaderError": {
  "NotAllowedError": "ERROR: you need to grant camera access permisson",
  "NotFoundError": "ERROR: no camera on this device",
  "NotSupportedError": "ERROR: secure context required (HTTPS, localhost)",
  "NotReadableError": "ERROR: is the camera already in use?",
  "OverconstrainedError": "ERROR: installed cameras are not suitable",
  "StreamApiNotSupportedError": "ERROR: Stream API is not supported in this browser"
  }
  },
  "se": {
  "QRReaderError": {
  "NotAllowedError": "ERROR: you need to grant camera access permisson",
  "NotFoundError": "ERROR: no camera on this device",
  "NotSupportedError": "ERROR: secure context required (HTTPS, localhost)",
  "NotReadableError": "ERROR: is the camera already in use?",
  "OverconstrainedError": "ERROR: installed cameras are not suitable",
  "StreamApiNotSupportedError": "ERROR: Stream API is not supported in this browser"
  }
  },
  "en": {
  "QRReaderError": {
  "NotAllowedError": "ERROR: you need to grant camera access permisson",
  "NotFoundError": "ERROR: no camera on this device",
  "NotSupportedError": "ERROR: secure context required (HTTPS, localhost)",
  "NotReadableError": "ERROR: is the camera already in use?",
  "OverconstrainedError": "ERROR: installed cameras are not suitable",
  "StreamApiNotSupportedError": "ERROR: Stream API is not supported in this browser"
  }
  }
  }
</i18n>

<style>

  .overlay:before, .overlay:after, .overlay em:after, .overlay em:before {
    border-color: #000;
    content: "";
    position: absolute;
    width: 15%;
    height: 15%;
    border: solid 3px tomato;
  }
  .overlay:before {
    left: 0;
    top: 0;
    border-right: none;
    border-bottom: none;
  }
  .overlay em:before {
    left: 0;
    bottom: 0;
    border-right: none;
    border-top: none;
  }
  .overlay em:after {
    right: 0;
    bottom: 0;
    border-left: none;
    border-top: none;
  }
  .overlay:after {
    right: 0;
    top: 0;
    border-left: none;
    border-bottom: none;
  }

  /* animated laser beam */
  .scanner {
    width: 100%;
    height: 3px;
    background-color: tomato;
    opacity: 0.7;
    position: relative;
    box-shadow: 0px 0px 3px 4px rgba(170, 11, 23, 0.49);
    top: 50%;
    animation-name: scan;
    animation-duration: 4s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  @keyframes scan {
    0% {
      box-shadow: 0px 0px 3px 4px rgba(170, 11, 23, 0.49);
      top: 50%;
    }

    25% {
      box-shadow: 0px 2px 3px 4px rgba(170, 11, 23, 0.49);
      top: 5px;
    }

    75% {
      box-shadow: 0px -2px 3px 4px rgba(170, 11, 23, 0.49);
      top: 98%;
    }
  }
</style>
